
const FAQ = [
  { cat: 'getting-started', q: 'How do I create a new workspace?',                a: 'Click your avatar in the top right, choose <strong>Account settings</strong>, then <strong>Workspaces → New workspace</strong>. You can be a member of multiple workspaces.' },
  { cat: 'getting-started', q: 'How do I invite team members?',                   a: 'Go to <strong>Settings → Team → + Invite member</strong>. You can invite by email or share a workspace invite link.' },
  { cat: 'getting-started', q: 'What\'s the difference between a project and a board?', a: 'A <strong>project</strong> is a long-lived workspace for a body of work. A <strong>board</strong> is a Kanban view inside a project. One project can have multiple boards.' },
  { cat: 'billing',         q: 'How do I change my billing plan?',                a: 'Go to <strong>Settings → Billing → Change plan</strong>. Upgrades are prorated to the current cycle; downgrades take effect at the next renewal.' },
  { cat: 'billing',         q: 'Can I get an invoice for past months?',           a: 'Yes — under <strong>Settings → Billing → Recent invoices</strong> there\'s a Download button next to every paid invoice.' },
  { cat: 'billing',         q: 'Do you support purchase orders?',                 a: 'Annual plans on the Enterprise tier support PO billing. <a href="mailto:sales@example.com">Contact sales</a> to set this up.' },
  { cat: 'security',        q: 'How do I enable two-factor authentication?',     a: 'Go to <strong>Settings → Privacy & security</strong> and toggle <strong>Two-factor authentication</strong> on. We support TOTP apps like 1Password, Authy, and Google Authenticator.' },
  { cat: 'security',        q: 'Where can I see my active sessions?',             a: 'Under <strong>Settings → Privacy & security → Active sessions</strong> you can see every signed-in device and revoke access to any of them.' },
  { cat: 'security',        q: 'Do you support SSO / SAML?',                      a: 'SSO is included on the Enterprise plan with SAML 2.0 support for Okta, Google Workspace, Azure AD, and JumpCloud.' },
  { cat: 'api',             q: 'Where do I find my API key?',                     a: 'Go to <strong>Settings → API keys</strong> to create new keys. Each key is shown once at creation time and not stored anywhere we can retrieve later.' },
  { cat: 'api',             q: 'What are the API rate limits?',                   a: 'Free: 60 req/min · Pro: 600 req/min · Enterprise: custom. Burst limits apply per endpoint.' },
  { cat: 'api',             q: 'Do you have webhooks?',                           a: 'Yes — configure them under <strong>Settings → Integrations → Webhooks</strong>. We sign every payload with HMAC-SHA256.' },
  { cat: 'account',         q: 'How do I change my email address?',               a: 'In <strong>Settings → Account</strong> change the email field and save. We\'ll send a confirmation link to the new address.' },
  { cat: 'account',         q: 'How do I delete my account?',                     a: 'Settings → Danger zone → Delete account. This is irreversible and removes all your data after a 30-day grace period.' },
  { cat: 'account',         q: 'Can I transfer workspace ownership?',             a: 'Yes — Settings → Danger zone → Transfer ownership. The new owner must already be a member of the workspace.' }
];

let activeCat = 'all';
let openIdx = -1;

function escapeHtml(s) { return String(s).replace(/[&<>"']/g, (c) => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c])); }

function render() {
  const q = document.getElementById('faq-search').value.trim().toLowerCase();
  const filtered = FAQ
    .map((item, idx) => ({ ...item, idx }))
    .filter((item) => activeCat === 'all' || item.cat === activeCat)
    .filter((item) => !q || item.q.toLowerCase().includes(q) || item.a.toLowerCase().includes(q));

  const list = document.getElementById('faq-list');
  const empty = document.getElementById('faq-empty');
  if (!filtered.length) {
    list.innerHTML = '';
    empty.hidden = false;
  } else {
    empty.hidden = true;
    list.innerHTML = filtered.map((item) => `
      <div class="faq-item${item.idx === openIdx ? ' open' : ''}" data-idx="${item.idx}">
        <button type="button" class="faq-q" aria-expanded="${item.idx === openIdx}">
          <span>${escapeHtml(item.q)}</span>
          <svg class="faq-chev" width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M4 6l4 4 4-4"/></svg>
        </button>
        <div class="faq-a">${item.a}</div>
      </div>
    `).join('');
  }
}

document.getElementById('faq-cats').addEventListener('click', (e) => {
  const btn = e.target.closest('.chip');
  if (!btn) return;
  e.stopPropagation();
  document.querySelectorAll('#faq-cats .chip').forEach((b) => b.classList.remove('active'));
  btn.classList.add('active');
  activeCat = btn.dataset.cat;
  openIdx = -1;
  render();
});

document.getElementById('faq-list').addEventListener('click', (e) => {
  const item = e.target.closest('.faq-item');
  if (!item) return;
  const idx = parseInt(item.dataset.idx, 10);
  openIdx = openIdx === idx ? -1 : idx;
  render();
});

let searchTimer;
document.getElementById('faq-search').addEventListener('input', () => {
  clearTimeout(searchTimer);
  searchTimer = setTimeout(render, 120);
});

render();
